"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Spinner = _interopRequireDefault(require("../elements/Spinner"));
var _PostMessage = require("../api/PostMessage");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
class Modal extends _react.default.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "closeModal", event => {
      const {
        closeModalCallback,
        display,
        header,
        fullWidth,
        isLoading
      } = this.props;
      this.setState({
        display: false,
        isLoading: false
      });
      if (typeof closeModalCallback !== 'undefined') {
        closeModalCallback(event);
      }
      _PostMessage.PostMessage.postMessageCoreEvent('modal-close', {
        display,
        header,
        fullWidth,
        isLoading
      });
    });
    const {
      display: _display,
      isLoading: _isLoading,
      header: _header,
      fullWidth: _fullWidth
    } = props;
    this.state = {
      display: _display,
      isLoading: _isLoading
    };
    _PostMessage.PostMessage.postMessageCoreEvent(_display ? 'modal-open' : 'modal-close', {
      display: _display,
      header: _header,
      fullWidth: _fullWidth,
      isLoading: _isLoading
    });
  }
  componentDidUpdate(prevProps) {
    const {
      display,
      isLoading,
      header,
      fullWidth
    } = this.props;
    if (typeof prevProps.display !== 'undefined' && prevProps.display !== display) {
      this.setState({
        display
      });
      _PostMessage.PostMessage.postMessageCoreEvent(display ? 'modal-open' : 'modal-close', {
        display,
        header,
        fullWidth,
        isLoading
      });
    }
    if (typeof prevProps.isLoading !== 'undefined' && prevProps.isLoading !== isLoading) {
      this.setState({
        isLoading
      });
      _PostMessage.PostMessage.postMessageCoreEvent(isLoading ? 'modal-loading' : 'modal-not-loading', {
        display,
        header,
        fullWidth,
        isLoading
      });
    }
  }
  render() {
    const {
      children,
      darkBackground,
      footer,
      header,
      showCloseIcon,
      isSuccessModal,
      fullWidth,
      portalContainer
    } = this.props;
    const {
      display,
      isLoading
    } = this.state;
    const modal = display && /*#__PURE__*/_react.default.createElement("div", {
      className: `modal is-active ${isSuccessModal ? 'success-modal' : ''}`,
      role: "alertdialog",
      "aria-modal": "true"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "modal-background"
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: `modal-card ${fullWidth ? 'is-full' : ''}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `lds-spinner-overlay ${isLoading && 'is-active'}`
    }, isLoading && /*#__PURE__*/_react.default.createElement(_Spinner.default, null)), /*#__PURE__*/_react.default.createElement("header", {
      className: `modal-card-head ${darkBackground ? 'has-gradient-blue' : 'has-background-white'}`
    }, /*#__PURE__*/_react.default.createElement("p", {
      className: `modal-card-title has-text-weight-bold is-size-3 ${darkBackground ? 'has-text-white' : ''}`
    }, header), showCloseIcon && !isLoading ? /*#__PURE__*/_react.default.createElement("button", {
      className: "icon is-small",
      "aria-label": "close",
      onClick: this.closeModal
    }, /*#__PURE__*/_react.default.createElement("i", {
      className: "material-icons has-text-weight-bold"
    }, "clear")) : null), /*#__PURE__*/_react.default.createElement("section", {
      className: `modal-card-body content ${darkBackground ? '' : 'has-paddingless-top'}`
    }, children), footer ? /*#__PURE__*/_react.default.createElement("footer", {
      className: "modal-card-foot"
    }, footer) : null));
    if (typeof portalContainer !== 'undefined' && portalContainer) {
      return /*#__PURE__*/_reactDom.default.createPortal(modal, portalContainer);
    }
    return modal;
  }
}
Modal.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  closeModalCallback: _propTypes.default.func,
  darkBackground: _propTypes.default.bool,
  footer: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.string]),
  fullWidth: _propTypes.default.bool,
  header: _propTypes.default.string,
  isSuccessModal: _propTypes.default.bool,
  showCloseIcon: _propTypes.default.bool,
  portalContainer: _propTypes.default.instanceOf(Element),
  display: _propTypes.default.bool,
  isLoading: _propTypes.default.bool
};
Modal.defaultProps = {
  children: [],
  darkBackground: true,
  fullWidth: false,
  showCloseIcon: true,
  portalContainer: undefined,
  display: true,
  isLoading: false
};
var _default = exports.default = Modal;
//# sourceMappingURL=Modal.js.map